import { useIsMobile } from 'hooks/useIsMobile';
import { GlobalPluginAlert } from './GlobalPluginAlert';
import { TwoFactorAlert } from './TwoFactorAlert';
import { useGlobalAlerts } from './useGlobalAlerts';

export function GlobalAlerts() {
  const { showExtensionWarning, showPasskeysWarning, dismiss } = useGlobalAlerts();
  const isMobile = useIsMobile();

  // GlobalPluginAlert renders nothing on a phone (there is no extension to install
  // there). Decided here too, or a phone with only that notice pending would get
  // the block's empty bordered frame.
  const showExtension = showExtensionWarning && !isMobile;
  const showWrapper = showExtension || showPasskeysWarning;

  if (!showWrapper) return null;

  // A direct child of the console's main column, which already spaces its
  // sections. The old page padding and bottom rule belonged to the shell this
  // replaced.
  //
  // One block with a hairline between rows, not a panel per notice: two notices
  // are one interruption, and two bordered panels with a gap read as two.
  return (
    <div className="bg-panel border-warn-line divide-line shrink-0 divide-y overflow-hidden rounded-panel border">
      {showExtension && <GlobalPluginAlert onClose={() => dismiss('Extension')} />}
      {showPasskeysWarning && <TwoFactorAlert onClose={() => dismiss('Passkeys')} />}
    </div>
  );
}
